import { type ReactNode } from 'react';

import { StepperHeader } from './StepperHeader';

type Props = {
  stepsTitles: string[];
  currentStepIndex: number;
  children: ReactNode;
  hasSpendeskLogo?: boolean;
  className?: string;
};

export function Stepper({
  stepsTitles,
  currentStepIndex,
  children,
  hasSpendeskLogo,
  className,
}: Props) {
  return (
    <div className={`mx-auto ${className || ''}`}>
      <StepperHeader
        steps={stepsTitles}
        currentStepIndex={currentStepIndex}
        hasSpendeskLogo={hasSpendeskLogo}
      />
      {children}
    </div>
  );
}
